import { isWeiXin, isAliPay, isAndroid, isIos, isWeiXinA } from '@/utils'
import { createPaymentOrder, paymentPayOrder } from '@/api/rechargeAct'
import { Toast } from 'vant'

/**
 *
 * 支付
 * 小程序：info:{orderId,orderPaySum}
 * 客户端|web：info:{channelId,orderId,sessionId,regionId,accessNum,type:aliPay | visaPay | wxPay}
 */

export const pay = (info = {}) => {
  if (isWeiXin) {
    let wx = window.wx,
      { orderId = '', orderPaySum = 0 } = info
    wx.miniProgram.getEnv(function (res) {
      if (res.miniprogram) {
        wx.miniProgram.postMessage({
          data: {
            orderId,
            orderPaySum,
          },
        })
        wx.miniProgram.redirectTo({
          url: '/pages/order/payCenter/index',
        })
      }
    })
  } else if (isAliPay) {
    let my = window.my,
      { orderId = '', orderPaySum = 0 } = info
    my.getEnv(function (res) {
      if (res.miniprogram) {
        my.postMessage({
          data: {
            orderId,
            orderPaySum,
          },
        })
        my.redirectTo({
          url: '/pages/order/payCenter/index',
        })
      }
    })
  } else if (isAndroid || isIos) {
    Toast.loading({
      message: '支付订单创建中，请稍后',
      duration: 0,
      forbidClick: true,
    })
    let {
      channelId = '',
      orderId = '',
      sessionId = '',
      regionId = '',
      accessNum = '',
      type = '',
    } = info
    //获取微信公众号内单点code || 相关配置信息
    const wxPayInfo = {
      clientAppid: 'wxd1f505517513a0b2', //客户端支付应用标识
      partnerid: '1625419801',
      package: 'Sign=WXPay',
    }
    let orderNo1 = ''
    //广电客户端
    createPaymentOrder({
      channelId,
      paymentModeId:
        type === 'visaPay' ? '2200' : type === 'aliPay' ? '2005' : '2104', // 支付方式
      orderId, // 订单id
    })
      .then((res) => {
        const { outTradeNo, orderNo } = res
        orderNo1 = orderNo
        return paymentPayOrder({
          sessionId,
          regionId, // 区号
          accessNum, // 手机号
          paymentModeId:
            type === 'visaPay' ? '2200' : type === 'aliPay' ? '2005' : '2104',
          channelId,
          outTradeNo: outTradeNo || '', // 外部订单号
          orderNo: orderNo || '', // 支付中心订单号
          buyerId: '1',
          paySuccessUrl: `${window.location.origin}${window.location.pathname}#/result`,
          appType: 'Wap', //客户端类型
          payClientCode: 'PERIPHERAL_CHANNELWXA0B2',
        })
      })
      .then((res) => {
        Toast.clear()
        let { signInfo = '', payNo = '' } = res.intfResultBean
        if (type === 'wxPay') {
          const { timestamp, noncestr, sign } = JSON.parse(signInfo)
          if (isAndroid) {
            window.android.nativeCall(
              JSON.stringify({
                type: 'payment',
                payload: {
                  mode: type,
                  data: JSON.stringify({
                    appid: wxPayInfo.clientAppid,
                    noncestr,
                    package: wxPayInfo.package,
                    partnerid: wxPayInfo.partnerid,
                    prepayid: payNo,
                    sign,
                    timestamp,
                  }),
                  orderNo: orderNo1,
                  notify: `${window.location.origin}${window.location.pathname}#/result`,
                },
              })
            )
          } else {
            window.webkit.messageHandlers.nativeCall.postMessage({
              type: 'payment',
              payload: {
                mode: type,
                data: JSON.stringify({
                  appid: wxPayInfo.clientAppid,
                  noncestr,
                  package: wxPayInfo.package,
                  partnerid: wxPayInfo.partnerid,
                  prepayid: payNo,
                  sign,
                  timestamp,
                }),
                orderNo: orderNo1,
                notify: `${window.location.origin}${window.location.pathname}#/result`,
              },
            })
          }
        } else {
          if (isAndroid) {
            window.android.nativeCall(
              JSON.stringify({
                type: 'payment',
                payload: {
                  mode: type,
                  data: type === 'aliPay' ? signInfo : payNo,
                  orderNo: orderNo1,
                  notify: `${window.location.origin}${window.location.pathname}#/result`,
                },
              })
            )
          } else {
            window.webkit.messageHandlers.nativeCall.postMessage({
              type: 'payment',
              payload: {
                mode: type,
                data: type === 'aliPay' ? signInfo : payNo,
                orderNo: orderNo1,
                notify: `${window.location.origin}${window.location.pathname}#/result`,
              },
            })
          }
        }
      })
      .catch((e) => {
        Toast.clear()
        e.message && Toast(e.message)
      })
  } else {
    //网页
    Toast.loading({
      message: '支付订单创建中，请稍后',
      duration: 0,
      forbidClick: true,
    })
    let {
      channelId = '',
      orderId = '',
      type = '',
      sessionId = '',
      regionId = '',
      accessNum = '',
      openid = '',
    } = info
    createPaymentOrder({
      channelId,
      paymentModeId:
        type === 'visaPay'
          ? '2201'
          : type === 'aliPay'
          ? '2002'
          : isWeiXinA
          ? '2106'
          : '2103', // 支付方式
      orderId, // 订单id
    })
      .then((res) => {
        const { outTradeNo, orderNo } = res
        let submitPayData = openid
          ? {
              sessionId,
              regionId, // 区号
              accessNum, // 手机号
              paymentModeId:
                type === 'visaPay'
                  ? '2201'
                  : type === 'aliPay'
                  ? '2002'
                  : isWeiXinA
                  ? '2106'
                  : '2103', // 支付类型
              channelId, //
              outTradeNo: outTradeNo || '', // 外部订单号
              orderNo: orderNo || '', // 支付中心订单号
              paySuccessUrl: `${window.location.origin}${window.location.pathname}#/result`,
              buyerId: openid,
              appType: 'Wap', //客户端类型
              payClientCode: 'PERIPHERAL_CHANNELWX07DA',
            }
          : {
              sessionId,
              regionId, // 区号
              accessNum, // 手机号
              paymentModeId:
                type === 'visaPay'
                  ? '2201'
                  : type === 'aliPay'
                  ? '2002'
                  : isWeiXinA
                  ? '2106'
                  : '2103', // 支付类型
              channelId, //
              outTradeNo: outTradeNo || '', // 外部订单号
              orderNo: orderNo || '', // 支付中心订单号
              paySuccessUrl: `${window.location.origin}${window.location.pathname}#/result`,
              buyerId: '1',
              appType: 'Wap', //客户端类型
            }
        return paymentPayOrder(submitPayData)
      })
      .then((res) => {
        Toast.clear()
        let { mwebUrl } = res.intfResultBean
        let signInfo = JSON.parse(res.intfResultBean.signInfo)
        if (type === 'aliPay') {
          //支付宝支付
          let alipayWrap = document.createElement('div')
          alipayWrap.setAttribute('id', 'alipayWrap')
          if (mwebUrl) {
            let newUrl =
              mwebUrl.slice(0, 5) + ' id="punchout_form"' + mwebUrl.slice(5)
            alipayWrap.innerHTML = newUrl
            document.body.appendChild(alipayWrap)
            alipayWrap.setAttribute('target', '_blank')
            let payFn = document.getElementById('punchout_form')
            payFn.submit()
          }
        } else if (type === 'visaPay') {
          //银联支付
          let payWrap = document.createElement('div')
          payWrap.setAttribute('id', 'payWrap')
          if (mwebUrl) {
            payWrap.innerHTML = mwebUrl
            document.body.appendChild(payWrap)
            payWrap.setAttribute('target', '_blank')
            let payFn = document.getElementById('pay_form')
            payFn.submit()
          }
        } else {
          if (isWeiXinA) {
            wx.chooseWXPay({
              timestamp: signInfo.timeStamp, // 支付签名时间戳，注意微信 jssdk 中的所有使用 timestamp 字段均为小写。但最新版的支付后台生成签名使用的 timeStamp 字段名需大写其中的 S 字符
              nonceStr: signInfo.nonceStr, // 支付签名随机串，不长于 32 位
              package: signInfo.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
              signType: signInfo.signType, // 微信支付V3的传入 RSA ,微信支付V2的传入格式与V2统一下单的签名格式保持一致
              paySign: signInfo.paySign, // 支付签名
              success: function (res) {
                // 支付成功后的回调函数
                //  支付成功
                console.log('支付成功', res)
                if (res.errMsg == 'chooseWXPay:ok') {
                  // 使用以上方式判断前端返回,微信团队郑重提示：
                  //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
                  window.location.href = `${window.location.origin}${window.location.pathname}#/result` // 支付成功回调
                }
              },
              //支付取消回调函数
              cancel: function (res) {
                console.log('用户取消支付', res)
              },
            })
          } else {
            //微信支付
            if (mwebUrl) {
              window.location.href = decodeURIComponent(mwebUrl)
            }
          }
        }
      })
      .catch((e) => {
        Toast.clear()
        e.message && Toast(e.message)
      })
  }
}
